import React from "react";
import styles from "./Locations.module.scss";
import cx from "classnames";
import Tabs from "@components/Tabs";
import FormProvider from "@providers/FormProvider";
import useSwiper from "@hooks/useSwiper";
import Swiper from "@components/Swiper";
import { Form, useFormik } from "formik";
import Card from "./Card";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
import Icons from "@gstyles/styleguide/icons";
import LocationService from "@services/LocationService";
import { useTranslationContext } from "@providers/TranslationProvider";
import helper, { discoverPage } from "@utils/helper";

// import { LOCATION_CATEGORIES } from "@utils/constant";
const ContentTab = ({ name = "", data }: any) => {
  const [reachEnd, $reachEnd] = React.useState(false);
  const [reachBeginning, $reachBeginning] = React.useState(true);

  useSwiper(`.location-swiper-${name}`, {
    speed: 1000,
    spaceBetween: 32,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      1080: {
        slidesPerView: 2,
      },
      1600: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: `.swiper-arrow-next-location-${name}`,
      prevEl: `.swiper-arrow-prev-location-${name}`,
    },
    on: {
      reachEnd: () => {
        _.debounce(() => {
          $reachEnd(true);
        }, 500)();
      },
      slideChange: (swiper) => {
        if (swiper) {
          $reachBeginning(false);
          $reachEnd(false);
        }
      },
      reachBeginning: () => {
        _.debounce(() => {
          $reachBeginning(true);
        }, 500)();
      },
    },
  });
  return (
    <div className={cx("inner-large", styles.swiperWrapper)}>
      <Icons
        name="chevron-right-outline"
        color="#000"
        className={cx(
          `swiper-arrow-prev-location-${name}`,
          styles.prevArrowIconMb
        )}
      />
      <Icons
        name="arrow-long-narrow-right"
        color="#2e281f"
        className={cx(
          `swiper-arrow-prev-location-${name}`,
          styles.prevArrowIcon,
          {
            invisible: reachBeginning,
            visible: !reachBeginning,
          }
        )}
      />

      <Swiper className={cx(`location-swiper-${name}`, styles.swiper)}>
        {_.map(data, (item: any, index: number) => {
          return (
            <Card
              style={{ minWidth: "340px" }}
              className={cx("swiper-slide")}
              {...item}
              key={`card_${name}_${index}`}
            />
          );
        })}
      </Swiper>

      <Icons
        name="arrow-long-narrow-right"
        color="#2e281f"
        className={cx(
          `swiper-arrow-next-location-${name}`,
          styles.nextArrowIcon,
          {
            invisible: reachEnd,
            visible: !reachEnd,
          }
        )}
      />
      <Icons
        name="chevron-right-outline"
        color="#F7EEDF"
        className={cx(
          `swiper-arrow-next-location-${name}`,
          styles.nextArrowIconMb,
          {
            invisible: reachEnd,
            visible: !reachEnd,
          }
        )}
      />
    </div>
  );
};
const ContentView = ({ slug, locations }: any) => {
  return (
    <>
      {!_.isEmpty(locations) && (
        <ContentTab
          name={slug}
          data={discoverPage.formatLocations(locations)}
        />
      )}
    </>
  );
};

const View = () => {
  const { i18n } = useTranslationContext();
  const { locationCategories, hotel } = usePageContext();
  const categories = _.compact(
    _.map(locationCategories, helper.formatCategory)
  );
  const form = useFormik({
    enableReinitialize: true,
    initialValues: {
      tab: _.get(categories, "0.slug"),
    },
    onSubmit: async () => {
      return true;
    },
  });
  const [TABS, $TABS]: any = React.useState([]);
  React.useEffect(() => {
    const result: any = [];
    _.map(categories, async (cat, index) => {
      // REFACTOR: nếu có thể query được category có locations thì chỉnh lại đoạn code này cho phù hợp.
      const res = await LocationService.find({
        locale: i18n.language,
        populate: "deep",
        filters: {
          category: {
            slug: {
              $eq: cat.slug,
            },
          },
          hotel: {
            slug: {
              $eq: hotel,
            },
          },
        },
      });
      const locations = _.get(res, "data", []);
      if (!_.isEmpty(locations)) {
        result.push({
          label: cat.name,
          key: cat.slug,
          value: cat.slug,
          children: <ContentView slug={cat.slug} locations={locations} />,
        });
      }
      if (categories.length === index + 1) $TABS(result);
    });
  }, [categories, hotel, i18n.language]);

  return (
    <section data-scroll-section className={styles.section}>
      <FormProvider form={form}>
        <Form>
          {!_.isEmpty(TABS) && (
            <Tabs
              border="none"
              theme="light"
              name="tab"
              items={TABS}
              selectStyle={{ boxSelect: styles.boxSelect }}
            />
          )}
        </Form>
      </FormProvider>
    </section>
  );
};
export default View;
